import { FC } from 'react';
import { DisplayMode } from '../enum/DisplayMode';
import LayoutOne, {
  ILayoutOneProps,
} from '../components/customiseContainer/customiseControls/featureLayouts/layoutOne/LayoutOne';
import LayoutTwo from '../components/customiseContainer/customiseControls/featureLayouts/layoutTwo/LayoutTwo';
import LayoutFour, {
  ILayoutFourProps,
} from '../components/customiseContainer/customiseControls/featureLayouts/layoutFour/LayoutFour';
import LayoutFive from '../components/customiseContainer/customiseControls/featureLayouts/layoutFive/LayoutFive';
import ServiceDisplay from '../components/customiseContainer/customiseControls/featureLayouts/serviceDisplay/ServiceDisplay';
import LayoutPD from '../components/customiseContainer/customiseControls/featureLayouts/layoutPD/LayoutPD';

const getFeatureLayoutComponent = (displayMode: DisplayMode): FC<ILayoutOneProps & ILayoutFourProps> => {
  switch (displayMode) {
    case DisplayMode.LAYOUT_ONE:
      return LayoutOne;
    case DisplayMode.LAYOUT_TWO:
      return LayoutTwo;
    case DisplayMode.LAYOUT_FOUR:
      return LayoutFour;
    case DisplayMode.LAYOUT_FIVE:
      return LayoutFive;
    case DisplayMode.LAYOUT_PD:
      return LayoutPD;
    case DisplayMode.SERVICE_PLAN:
      return ServiceDisplay;
    default:
      return LayoutFour;
  }
};

export default getFeatureLayoutComponent;
